import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "../ui/card";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../ui/select";
import { Home } from "lucide-react";

export function PropertyDetailsSection({
  presentValue,
  setPresentValue,
  homeArea,
  setHomeArea,
  loanAmount,
  setLoanAmount,
  currentRental,
  setCurrentRental,
  lotSize,
  setLotSize,
  hasPool,
  setHasPool,
  readOnly = false,
}) {
  return (
    <Card className="shadow-md">
      <CardHeader className="p-4 sm:p-6">
        <CardTitle className="flex items-center gap-2 text-base sm:text-lg">
          <Home className="h-4 w-4 sm:h-5 sm:w-5 text-primary flex-shrink-0" />
          Current Property Details
        </CardTitle>
      </CardHeader>
      <CardContent className="p-4 sm:p-6 pt-0">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-6">
          <div className="space-y-2">
            <Label htmlFor="present-value" className="text-xs sm:text-sm">
              Present Value of Home ($)
            </Label>
            <Input
              type="number"
              id="present-value"
              value={presentValue}
              onChange={(e) => setPresentValue(e.target.value)}
              onWheel={(e) => e.target.blur()}
              disabled={readOnly}
            />
            <p className="text-xs sm:text-sm text-muted-foreground">
              ${Number(presentValue).toLocaleString()} ($
              {Math.ceil(
                Number(presentValue) / Number(homeArea)
              ).toLocaleString()}{" "}
              per sq ft)
            </p>
          </div>
          <div className="space-y-2">
            <Label htmlFor="home-area" className="text-xs sm:text-sm">
              Home Area (sq ft)
            </Label>
            <Input
              type="number"
              id="home-area"
              value={homeArea}
              onChange={(e) => setHomeArea(e.target.value)}
              onWheel={(e) => e.target.blur()}
              disabled={readOnly}
            />
          </div>
          <div className="space-y-2">
            <Label htmlFor="loan-amount" className="text-xs sm:text-sm">
              Open Loan Balance ($)
            </Label>
            <Input
              type="number"
              id="loan-amount"
              value={loanAmount}
              onChange={(e) => setLoanAmount(e.target.value)}
              onWheel={(e) => e.target.blur()}
              disabled={readOnly}
            />
            <p className="text-xs sm:text-sm text-muted-foreground">
              ${Number(loanAmount).toLocaleString()}
            </p>
          </div>
          <div className="space-y-2">
            <Label htmlFor="current-rental" className="text-xs sm:text-sm">
              Current Estimated Monthly Rental ($)
            </Label>
            <Input
              type="number"
              id="current-rental"
              value={currentRental}
              onChange={(e) => setCurrentRental(e.target.value)}
              onWheel={(e) => e.target.blur()}
              disabled={readOnly}
            />
            <p className="text-xs sm:text-sm text-muted-foreground">
              ${Number(currentRental).toLocaleString()}
            </p>
          </div>
          <div className="space-y-2">
            <Label htmlFor="lot-size" className="text-xs sm:text-sm">
              Lot Size (sq ft)
            </Label>
            <Input
              type="number"
              id="lot-size"
              value={lotSize}
              onChange={(e) => setLotSize(e.target.value)}
              onWheel={(e) => e.target.blur()}
              disabled={readOnly}
            />
          </div>
          <div className="space-y-2">
            <Label htmlFor="has-pool" className="text-xs sm:text-sm">
              Pool
            </Label>
            <Select value={hasPool} onValueChange={setHasPool} disabled={readOnly}>
              <SelectTrigger>
                <SelectValue />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="no">No</SelectItem>
                <SelectItem value="yes">Yes</SelectItem>
              </SelectContent>
            </Select>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
